export default {
  banner: {
    title: "Authing 合作伙伴体系",
    subtitle: "从双赢到多赢",
    join: "立即加入",
  },
  feature: {
    item1: {
      title: "以身份为核心的零信任服务网络",
      text:
        "远程办公趋势下，以身份为核心的零信任安全服务为广大企业的核心资产，信息安全和人员访问提供多因素验证，端到端、人到端安全审计，统一身份管理和统一权限管理能力，深度赋能企业零信任网络建设。",
    },
    item2: {
      title: "千亿级身份云市场",
      text:
        "随着国内云计算和 SaaS 服务的普及，身份作为企业基础服务的属性突显。以安全为切入点的身份互联网有效解决新互联时代下的管理痛点，解锁 1200 亿蓝海市场。",
    },
    item3: {
      title: "IDaaS 发展速度迅猛",
      text:
        "据 Gartner 统计，2019 年身份和访问管理安全全球市场支出为 105.8 亿美元；2024 年我国身份访问管理市场规模将达到 30 亿元，传统 IAM 向 IDaaS 发展的趋势明显。",
    },
    item4: {
      title: "国产创新政策加持",
      text:
        " 创新作为中国软件的关键顶层设计，将为兼具自主可控能力的头部供应商营造良好的发展环境；同时中国信息安全法日益完善，促使企业寻求专业的合规性解决方案。",
    },
  },
  system: {
    title: "合作伙伴类型",
    item1: {
      title: "渠道合作伙伴",
      text:
        "我们的渠道合作伙伴通过代理或集成 Authing 产品，联合拓展产品市场规模，共同提升产品服务能力和建造身份行业影响力，共同服务客户全生命周期旅程。",
    },
    item2: {
      title: "生态合作伙伴",
      text:
        "我们的生态合作伙伴是技术合作伙伴或 ISV，他们拥有独特的技术或解决方案来增进我们的产品能力。他们通过 Authing 合作网络集成和解决方案联动，拓展了客户的使用场景和简化了客户的开发流程。",
    },
    item3: {
      title: "管理服务提供商",
      text:
        "管理服务提供商代表他们的客户实施和运行 Authing 实例，提供专业知识，为他们的客户带来世界级的身份产品和服务。",
    },
  },
  equity: {
    title1: "渠道合作",
    title2: "伙伴权益",
    item1: "专属产品折扣",
    item2: "客户测试支持",
    item3: "定点团队支持",
    item4: "专享大幅返点",
    item5: "定期人员培训",
    item6: {
      title: "厂商商机直达",
      extra: "铂金级渠道专享",
    },
  },
  form: {
    title: "申请成为 Authing 合作伙伴",
    company: "企业名称",
    email: "企业邮箱",
    address: "企业所在地",
    name: "姓名",
    phone: "手机号",
    intend: "合作方向",
  },
};
